import { useContext } from 'react'
import {
  GlobalDataContext,
  TemplateContext,
  propsDataLocationToPathAndValue,
} from '@ea-lab/reactive-json'
import { UnitDataBaseContext } from './unitDataBaseContext'
import { resolveRowContext } from './rowPaths'

/**
 * Row/cell context of a primitive rendered inside a Switch iteration — where
 * the current row sits relative to its top-level field (see `rowPaths.js`).
 * Shared by `BuilderRowField`, `BuilderRowAction` and `BuilderRowToolbar`.
 *
 * @param {{field: string, column?: string}} props
 * @param {string} path       the reactive-json render path of the primitive
 * @param {string} datafield  the reactive-json datafield of the primitive
 */
export const useRowContext = ({ field, column }, path, datafield) => {
  const globalDataContext = useContext(GlobalDataContext)
  const templateContext = useContext(TemplateContext)
  const dataBase = useContext(UnitDataBaseContext)

  const resolve = (dataLocation) =>
    propsDataLocationToPathAndValue({
      currentPath: path,
      datafield,
      dataLocation,
      defaultValue: undefined,
      globalDataContext,
      templateContext,
    })
  const resolvePath = (dataLocation) => resolve(dataLocation).formDataPath

  const ctx = resolveRowContext({ field, column, resolvePath, dataBase })
  // Live value of the top-level field (the whole array): lets a toolbar know
  // how many siblings its row has (first row → no "up", last row → no "down").
  const topValue = ctx.topField ? resolve(`${dataBase}.${ctx.topField}`).formData : undefined
  return { ...ctx, topValue }
}
